import React, { useState } from "react";
import { Row, Col, Card, Button, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const RecentTransactions = () => {
  const [activeTab, setActiveTab] = useState("expired");

  /* ================= DATA ================= */

  const transactions = [
    {
      name: "Stellar Dynamics",
      id: "#12457",
      amount: "+$245",
      plan: "Basic (Monthly)",
      img: "/assets/img/company/company-02.svg",
    },
    {
      name: "Quantum Nexus",
      id: "#65974",
      amount: "+$395",
      plan: "Enterprise (Yearly)",
      img: "/assets/img/company/company-03.svg",
    },
    {
      name: "Aurora Technologies",
      id: "#22457",
      amount: "+$145",
      plan: "Advanced (Monthly)",
      img: "/assets/img/company/company-05.svg",
    },
    {
      name: "TerraFusion Energy",
      id: "#43412",
      amount: "+$145",
      plan: "Enterprise (Monthly)",
      img: "/assets/img/company/company-07.svg",
    },
    {
      name: "Epicurean Delights",
      id: "#43567",
      amount: "+$977",
      plan: "Premium (Yearly)",
      img: "/assets/img/company/company-08.svg",
    },
  ];

  const registered = [
    {
      name: "Pitch",
      plan: "Basic (Monthly)",
      users: "150 Users",
      domain: "pitch.example.com",
      img: "/assets/img/icons/company-icon-11.svg",
    },
    {
      name: "Initech",
      plan: "Enterprise (Yearly)",
      users: "200 Users",
      domain: "initech.example.com",
      img: "/assets/img/icons/company-icon-12.svg",
    },
    {
      name: "Umbrella Corp",
      plan: "Advanced (Monthly)",
      users: "129 Users",
      domain: "umbcorp.example.com",
      img: "/assets/img/icons/company-icon-13.svg",
    },
    {
      name: "Capital Partners",
      plan: "Enterprise (Monthly)",
      users: "103 Users",
      domain: "capitalpart.example.com",
      img: "/assets/img/icons/company-icon-14.svg",
    },
    {
      name: "Massive Dynamic",
      plan: "Premium (Yearly)",
      users: "108 Users",
      domain: "msdynamic.example.com",
      img: "/assets/img/icons/company-icon-15.svg",
    },
  ];

  const expired = [
    {
      name: "Silicon Corp",
      date: "10 Apr 2025",
      plan: "Basic (Monthly)",
      img: "/assets/img/icons/company-icon-16.svg",
    },
    {
      name: "Hubspot",
      date: "12 Jun 2025",
      plan: "Enterprise (Yearly)",
      img: "/assets/img/icons/company-icon-14.svg",
    },
    {
      name: "Licon Industries",
      date: "16 Jun 2025",
      plan: "Advanced (Monthly)",
      img: "/assets/img/icons/company-icon-18.svg",
    },
    {
      name: "TerraFusion Energy",
      date: "12 May 2025",
      plan: "Enterprise (Monthly)",
      img: "/assets/img/company/company-07.svg",
    },
    {
      name: "Epicurean Delights",
      date: "15 May 2025",
      plan: "Premium (Yearly)",
      img: "/assets/img/company/company-08.svg",
    },
  ];

  /* ================= UI ================= */

  return (
    <Row className="g-4 mx-2">
      {/* ================= Recent Transactions ================= */}
      <Col xxl={4} xl={12}>
        <Card className="shadow-sm border-0 ">
          <Card.Header className="bg-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-semibold">Recent Transactions</h5>
            <Button variant="light" size="sm">
              View All
            </Button>
          </Card.Header>

          <Card.Body>
            {transactions.map((item, i) => (
              <div
                key={i}
                className="d-flex justify-content-between align-items-center mb-3"
              >
                <div className="d-flex align-items-center">
                  <div className="bg-light rounded-circle p-2 me-3">
                    <img src={item.img} alt="" width="32" />
                  </div>
                  <div>
                    <h6 className="mb-1 fw-semibold">{item.name}</h6>
                    <small>
                      <span className="text-info">{item.id}</span> • 14 Jan 2025
                    </small>
                  </div>
                </div>

                <div className="text-end">
                  <h6 className="mb-1 fw-semibold">{item.amount}</h6>
                  <small className="text-muted">{item.plan}</small>
                </div>
              </div>
            ))}
          </Card.Body>
        </Card>
      </Col>

      {/* ================= Recently Registered ================= */}
      <Col xxl={4} xl={6}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Header className="bg-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-semibold">Recently Registered</h5>
            <Button variant="light" size="sm">
              View All
            </Button>
          </Card.Header>

          <Card.Body>
            {registered.map((item, i) => (
              <div
                key={i}
                className="d-flex justify-content-between align-items-center mb-3"
              >
                <div className="d-flex align-items-center">
                  <div className="bg-light rounded-circle p-2 me-3">
                    <img src={item.img} alt="" width="32" />
                  </div>
                  <div>
                    <h6 className="mb-1 fw-semibold">{item.name}</h6>
                    <small className="text-muted">{item.plan}</small>
                  </div>
                </div>

                <div className="text-end">
                  <small className="d-block">{item.users}</small>
                  <small className="text-muted">{item.domain}</small>
                </div>
              </div>
            ))}
          </Card.Body>
        </Card>
      </Col>

      {/* ================= Recent Plan Expired ================= */}
      <Col xxl={4} xl={6}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Header className="bg-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-semibold">Recent Plan Expired</h5>

            <Dropdown>
              <Dropdown.Toggle variant="light" size="sm">
                {activeTab === "expired" ? "Expired" : "Request"}
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <Dropdown.Item onClick={() => setActiveTab("expired")}>
                  Expired
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setActiveTab("request")}>
                  Request
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Card.Header>

          <Card.Body>
            {activeTab === "expired" &&
              expired.map((item, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center mb-3"
                >
                  <div className="d-flex align-items-center">
                    <div className="bg-light rounded-circle p-2 me-3">
                      <img src={item.img} alt="" width="32" />
                    </div>
                    <div>
                      <h6 className="mb-1 fw-semibold">{item.name}</h6>
                      <small className="text-muted">
                        Expired : {item.date}
                      </small>
                    </div>
                  </div>

                  <div className="text-end">
                   <Link className=" text-decoration-underline d-block">
                     Send Reminder
                    </Link>
                    <small className="text-muted">{item.plan}</small>
                  </div>
                </div>
              ))}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default RecentTransactions;